@for (property of properties; track property.Id) {
  <div
    class="property"
    (mouseenter)="openWindow(property.Id)"
    id="property-{{ property.Id }}"
  >
    <a
      class="property-content"
      [routerLink]="[
        '/' +
          (settings.ClientId == 4
            ? (property.LongUrl ?? 'hotell/' + property.Url)
            : 'hotell/' + property.Url),
      ]"
      target="_blank"
    >
      <div class="image-wrapper">
        @if (property.TopMedia && property.TopMedia.Url) {
          <img
            [src]="
              property.TopMedia.Url
                | apiImage: 320 : property.TopMedia : 'fill' : 320
            "
            [alt]="property.Name"
            loading="lazy"
            [height]="320"
            [width]="320"
          />
        }
        @if (property.OverallRating && property.OverallRating > 0) {
          <div
            class="c-rating"
            matTooltip="Basert på {{ property.NumberOfReviews }} vurderinger"
          >
            {{ property.OverallRating.toFixed(1) }}
          </div>
        }
      </div>
      <div class="content">
        <div class="ribbon">
          <span>
            @for (star of getRatingArray(property.Rating); track star) {
              <span>★</span>
            }
          </span>
        </div>
        <div class="location">
          {{ property.Location.City?.Name }}
        </div>
        <div class="name">
          {{ property.Name }}
        </div>
        <div class="description">
          {{ property.ShortDescription }}
        </div>
      </div>
    </a>
  </div>
}
